<template>
  <div class="sidebarAggregator">
    <transition-group name="slideRight" tag="div">
      <tabs-sidebar v-for="sidebar in sidebars"
                    :key="sidebar.uuid"
                    :sidebar-name="sidebar.component"
                    style="animation-duration: .4s;">
        <component :is="sidebar.component.name" :key="sidebar.component.uuid" v-bind="sidebar.component.props"></component>
      </tabs-sidebar>
    </transition-group>
  </div>
</template>
<script>
  export default {
    components: {
    },
    computed: {
      sidebars () {
        return this.$store.state.tabsSidebar.sidebars
      }
    }
  }
</script>
<style lang="scss">
  .sidebarAggregator{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 31;
    height: 100%;
    & > div{
      height: 100%;
    }
  }
</style>